import React, { useState } from 'react';
import HistoricalChart from './HistoricalChart';
import CountyStatistics from './CountyStatistics';
import ReferenceMonitor from './ReferenceMonitor';

// A single card that houses the county-wide views behind tabs so they fit within
// the fixed iframe height. County-wide daily trend is the default tab.
const TABS = [
  { key: 'trend', label: 'County Trend' },
  { key: 'exceedance', label: 'Exceedance / Year' },
  { key: 'zip', label: 'By Zip Code' },
  { key: 'reference', label: 'Reference Monitor' }
];

const CountyPanel = () => {
  const [tab, setTab] = useState('trend');
  // Track which tabs have been opened so each fetches once, then stays mounted
  // (hidden via CSS) — switching tabs never refetches.
  const [visited, setVisited] = useState({ trend: true });
  const isStats = tab === 'exceedance' || tab === 'zip';
  const statsVisited = visited.exceedance || visited.zip;

  const selectTab = (key) => {
    setTab(key);
    setVisited(v => (v[key] ? v : { ...v, [key]: true }));
  };

  return (
    <div className="p-3 bg-white rounded-lg shadow-md">
      <div className="flex gap-1 mb-2 border-b overflow-x-auto">
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => selectTab(t.key)}
            className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px whitespace-nowrap ${
              tab === t.key
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Each panel mounts on first visit and stays mounted; the inactive one is
          hidden with display:none so tab switches never trigger a refetch. */}
      <div className={tab === 'trend' ? '' : 'hidden'}>
        <HistoricalChart type="county" bare />
      </div>
      {statsVisited && (
        <div className={isStats ? '' : 'hidden'}>
          <CountyStatistics bare only={tab === 'zip' ? 'zip' : 'exceedance'} />
        </div>
      )}
      {visited.reference && (
        <div className={tab === 'reference' ? '' : 'hidden'}>
          <ReferenceMonitor />
        </div>
      )}
    </div>
  );
};

export default CountyPanel;
